// SPDX-License-Identifier: EUPL-1.2
/*
 * Copyright (c) 2025, European Commission. Licensed under the EUPL-1.2
 * Authors:
*   Andrea Stefanutti
 */

import { CHART_INFO_POSITION } from '@app/utils/constants';
import { Chart as ChartJS } from 'chart.js';

ChartJS.defaults.font.family = '"Open Sans", sans-serif';

export type POSITION = (typeof CHART_INFO_POSITION)[keyof typeof CHART_INFO_POSITION];

export const getChartOptions = (title: string, legendPosition: POSITION, showXgrid?: boolean, showYgrid?: boolean) => {
	return {
		responsive: true,
		maintainAspectRatio: false,
		plugins: {
			legend: {
				position: legendPosition
			},
			title: {
				display: true,
				text: title
			}
		},
		scales: {
			x: {
				type: 'category' as const,
				display: true,
				ticks: {
					color: 'rgba(0,0,0,1)' // labels color
				},
				// visibility X axis
				border: {
					display: true,
					color: 'rgba(0,0,0,0.6)',
					width: 1
				},
				// Grid that comes out from the X axis, so the vertical lines
				grid: {
					display: showYgrid ?? true, // show grid's vertical lines
					drawOnChartArea: true, // show grid on chart area
					drawTicks: true, // show labels tick
					drawBorder: true, // show axis borders
					color: 'rgba(0,0,0,0.3)', // grid color
					lineWidth: 1,
					borderDash: [] as number[] // [4,4] hatching
				}
			},
			// visibility Y axis
			y: {
				type: 'linear' as const,
				display: true,
				ticks: {
					color: 'rgba(0,0,0,0.7)', // labels color
					beginAtZero: false
				},
				border: {
					display: true,
					color: 'rgba(0,0,0,0.6)',
					width: 1
				},
				// Grid that comes out from the Y axis, so the horizontal lines
				grid: {
					display: showXgrid ?? true, // show grid's horizontal lines
					drawOnChartArea: true, // show grid on chart area
					drawTicks: true, // show labels tick
					drawBorder: true, // show axis borders
					color: 'rgba(0,0,0,0.3)', // grid color
					lineWidth: 1,
					borderDash: [] as number[] // [4,4] hatching
				}
			}
		}
	};
};
